import { LoaderRow } from "@circle-react-shared/LoaderRow";
import { Form } from "@circle-react-uikit/Form";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useSpaceGroupsContext } from "@circle-react/contexts/spaceGroupsContext";
import { noop } from "lodash";

import { legacyClassNames } from "@/react/helpers/cssAnchorHelpers";

import { AccessSection } from "./components/sections/AccessSection";
import { CourseFlow } from "./components/sections/CourseFlow";
import { GeneralSection } from "./components/sections/GeneralSection";
import { NotificationsSection } from "./components/sections/NotificationsSection";
import { FORM_ID } from "./constants";
import { useCreateSpaceSubmit } from "./hooks/useCreateSpaceSubmit";
import { useSpaceFormDefaults } from "./hooks/useSpaceFormDefaults";
import type { NewV3Props, SpaceFormValues } from "./types";
import { isCoursePostType } from "./utils/spaceTypePredicates";

export const NewForm = ({
  onClose,
  currentSpaceGroupId,
  post_type = "basic",
  courseSetting,
  prefillData,
  setExternalDisabledState = noop,
  setExternalLoadingState = noop,
}: NewV3Props) => {
  const { currentCommunityMember } = usePunditUserContext();
  const canCreateAllTypesOfSpaces = Boolean(currentCommunityMember?.is_admin);
  const {
    helpers: { isDataLoading: isSpaceGroupsDataLoading },
  } = useSpaceGroupsContext();

  const defaultValues = useSpaceFormDefaults({
    canCreateAllTypesOfSpaces,
    courseSetting,
    currentSpaceGroupId,
    post_type,
    prefillData,
  });

  const { handleSubmit } = useCreateSpaceSubmit({
    onClose,
    setExternalLoadingState,
  });

  if (isSpaceGroupsDataLoading()) {
    return <LoaderRow />;
  }

  const isCourse = isCoursePostType(post_type);

  return (
    <Form<SpaceFormValues>
      id={FORM_ID}
      onSubmit={handleSubmit}
      defaultValues={defaultValues}
      className={legacyClassNames("create-space__form")}
    >
      {isCourse ? (
        <CourseFlow
          currentSpaceGroupId={currentSpaceGroupId}
          onImageProcessing={setExternalDisabledState}
        />
      ) : (
        <div className="flex flex-col gap-y-4">
          <GeneralSection currentSpaceGroupId={currentSpaceGroupId} />
          <AccessSection />
          <NotificationsSection />
        </div>
      )}
    </Form>
  );
};
